import React from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';

import * as Urls from 'src/constants/EndpointUrls';
import Button from 'jbc-front/components/Button';
import { getClientPayrollRulesGroups } from 'src/reducers/employees/employeePays';
import { setGlobalWarnings } from 'src/reducers/global';
import { openNewTab } from 'src/utils/Http';

import {
  takePayConfirmedStateFromSearchForm,
  takePaysQueriedUrl,
  takePaysFbDataUrl,
  takeInhabitantTaxFbDataUrl,
  getPayTitle,
  FORM_NAME_PAYS_SEARCH
} from 'src/reducers/searchForm';
import EmployeePaysMethod from './EmployeePaysMethod';
import ExportDocumentMethod from './ExportDocumentMethod';
import AllowanceDeductionsMethod from './AllowanceDeductionsMethod';
import DownloadPayReports from '../containers/DownloadPayReportsContainer';
import styles from './ActionSection.scss';
import { withTranslation } from 'react-i18next';

class ActionSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isPayrollBaloonOpen: false,
      isInhabitantTaxOpen: false,
      isAllowanceDeductionsOpen: false,
      isExportDocumentOpen: false
    };
  }

  render() {
    const {
      payrollRulesGroups,
      yearMonth,
      downloadTemplateCsvPageUrl,
      showPayFbDataUrl,
      inhabitantTaxFBPageUrl,
      downloadZipUrl,
      isConfirmed,
      bulkModalOpen,
      openBulkModal,
      hideBulkModal
    } = this.props;

    return (
      <div className={styles.wrap}>
        <div className={styles.button}>
          <Button
            widthAuto
            className="ignore-react-onclickoutside"
            onClick={() =>
              this.setState({
                isAllowanceDeductionsOpen: !this.state.isAllowanceDeductionsOpen,
                isPayrollBaloonOpen: false,
                isInhabitantTaxOpen: false,
                isExportDocumentOpen: false
              })
            }
          >
            {this.props.t('features.EmployeePays.components.ActionSection.Provision_and_deduction_items')}
          </Button>
          {this.state.isAllowanceDeductionsOpen && (
            <AllowanceDeductionsMethod
              hide={() => this.setState({ isAllowanceDeductionsOpen: false })}
              downloadTemplateCsvPageUrl={downloadTemplateCsvPageUrl}
              isConfirmed={isConfirmed}
            />
          )}
        </div>
        <div className={styles.button}>
          <Button
            widthAuto
            className="ignore-react-onclickoutside"
            disabled={!isConfirmed}
            onClick={() =>
              this.setState({
                isPayrollBaloonOpen: !this.state.isPayrollBaloonOpen,
                isInhabitantTaxOpen: false,
                isAllowanceDeductionsOpen: false,
                isExportDocumentOpen: false
              })
            }
          >
            {this.props.t('features.EmployeePays.components.ActionSection.Salary_transfer')}
          </Button>
          <EmployeePaysMethod
            hide={() => this.setState({ isPayrollBaloonOpen: false })}
            showPayFbDataUrl={showPayFbDataUrl}
            isConfirmed={isConfirmed}
            isOpen={this.state.isPayrollBaloonOpen}
          />
        </div>
        {/* <div className={styles.button}>
          <Button
            widthAuto
            className="ignore-react-onclickoutside"
            disabled={!isConfirmed}
            onClick={() =>
              this.setState({
                isExportDocumentOpen: !this.state.isExportDocumentOpen,
                isPayrollBaloonOpen: false,
                isInhabitantTaxOpen: false,
                isAllowanceDeductionsOpen: false
              })
            }
          >
            {this.props.t('features.EmployeePays.components.ActionSection.Create_document')}
          </Button>
          <ExportDocumentMethod
            hide={() => this.setState({ isExportDocumentOpen: false })}
            isConfirmed={isConfirmed}
            isOpen={this.state.isExportDocumentOpen}
          />
        </div> */}
        {/* <div className={styles.button}>
          <Button
            widthAuto
            className="ignore-react-onclickoutside"
            disabled={!isConfirmed}
            onClick={() => {
              openNewTab(inhabitantTaxFBPageUrl);
            }}
          >
            {this.props.t('features.EmployeePays.components.ActionSection.Resident_tax_list')}
          </Button>
        </div> */}
        <DownloadPayReports
          {...{
            payrollRulesGroups,
            yearMonth,
            downloadZipUrl,
            isConfirmed,
            bulkModalOpen,
            openBulkModal,
            hideBulkModal
          }}
        />
      </div>
    );
  }
}

export default withTranslation('translation')(connect(
  state => {
    const extras = { jobInfo: getPayTitle(getFormValues(FORM_NAME_PAYS_SEARCH)(state), state) };
    const formQueries = getFormValues(FORM_NAME_PAYS_SEARCH)(state);

    return {
      downloadTemplateCsvPageUrl: takePaysQueriedUrl(Urls.EMPLOYEE_PAY_DOWNLOAD_CSV_PAGE, formQueries, false, extras),
      downloadZipUrl: takePaysQueriedUrl(Urls.PAY_DETAIL_PDF, formQueries, true, extras),
      clientPayrollRulesGroups: getClientPayrollRulesGroups(state),
      showPayFbDataUrl: takePaysFbDataUrl(state),
      inhabitantTaxFBPageUrl: takeInhabitantTaxFbDataUrl(state),
      isConfirmed: takePayConfirmedStateFromSearchForm(state, FORM_NAME_PAYS_SEARCH)
    };
  },
  dispatch => ({
    displayWarnings: msg => dispatch(setGlobalWarnings(msg))
  })
)(ActionSection));
